import React, { useRef } from 'react';
import './demo-wrapper.scss';
import { Intent } from '../common';
import { Button, AchorButton, ButtonProps } from '../components';
import { useState } from 'react';

const ButtonWrapper = () => {
  const buttonRef = useRef(null);
  const selectRef = useRef(null);

  const _buttonProps: ButtonProps = {
    icon: 'Save',
    minimal: false,
    outlined: false,
    disabled: false,
  };
  const [buttonProps, setButtonProps] = useState(_buttonProps);

  const intentList: Array<Intent> = [
    'primary',
    'secondary',
    'tertiary',
    'success',
    'notice',
    'warning',
  ];

  const handleOnclick = () => {
    console.log('Clicked!!');
    window.alert('clicked');
  };

  const changeButtonIntent = () => {
    if (selectRef?.current) {
      const buttonType = selectRef.current.value;
      switch (buttonType) {
        case 'minimal':
          setButtonProps({ ..._buttonProps, minimal: true });
          break;
        case 'outlined':
          setButtonProps({ ..._buttonProps, outlined: true });
          break;
        case 'disabled':
          setButtonProps({ ..._buttonProps, disabled: true });
          break;
        default:
          setButtonProps(_buttonProps);
      }
    }
  };

  return (
    <>
      <h1>📌 Button</h1>
      <div className="option-container">
        <select onChange={changeButtonIntent} ref={selectRef}>
          <option value="">default</option>
          <option value="minimal">minimal(ghost)</option>
          <option value="outlined">outlined</option>
          <option value="disabled">disabled</option>
        </select>
      </div>
      {intentList.map((i) => (
        <div className="demo-wrapper" key={i}>
          <h3>{i}</h3>
          <section>
            <Button intent={i} onClick={handleOnclick}>
              {i}
            </Button>
            <Button intent={i} outlined icon="ArrowDown" ref={buttonRef}>
              outlined
            </Button>
            <Button intent={i} minimal text="text"></Button>
            <Button intent={i} rightIcon="Save" disabled>
              disabled
            </Button>
            <AchorButton
              intent={i}
              href="https://google.com"
              icon="AddCell"
              rightIcon="Save"
              target="_blank"
            >
              AchorButton
            </AchorButton>
          </section>
          {/*  */}
          <section>
            <Button intent={i} text={i} size={24} {...buttonProps} />
            <Button intent={i} text={i} size={32} {...buttonProps} />
            <Button intent={i} text={i} size={40} {...buttonProps} />
            <Button intent={i} text={i} size={48} {...buttonProps} />
            <Button intent={i} text={i} size={56} {...buttonProps} />
          </section>
          {/*  */}
          <section>
            <Button intent={i} text={i} size={24} iconsOnly {...buttonProps} />
            <Button intent={i} text={i} size={32} iconsOnly {...buttonProps} />
            <Button intent={i} text={i} size={40} iconsOnly {...buttonProps} />
            <Button intent={i} text={i} size={48} iconsOnly {...buttonProps} />
            <Button intent={i} text={i} size={56} iconsOnly {...buttonProps} />
          </section>
        </div>
      ))}
    </>
  );
};

export default ButtonWrapper;
